export default {

    //获取订单列表
    findOrderList: '/bygOrder/find',

    //获取商品列表
    findProduct: '/bygOrder/findProduct',

    //获取支付方式列表
    findPayType: '/bygOrder/findPayType',

    //添加订单备注
    addRemark: '/bygOrder/addRemark',

    //订单退款
    payRefund: '/bygOrder/payRefund',

    //获取订单日志列表
    findOrderLog: '/bygOrder/findLog',

    //获取续费纪念堂二维码
    getRenewQRCode: '/bygOrder/getRenewQRCode',

    //获取购买纪念堂二维码
    getPurchaseQRCode: '/bygOrder/getPurchaseQRCode',
  
  }


// WEBPACK FOOTER //
// ./src/api/Online/urls.js